<template>
  <div>
    <template v-if="profile_data.score_alert">
      <div class="profile-score-alert" v-if="profile_data.score_alert.sexy">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        男性向けのコンテンツが多めです。
      </div>
      <div class="profile-score-alert" v-if="profile_data.score_alert.female_audience">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        女性中心のフォロワーのため、男性向け商材のPRに不向きです。
      </div>
      <div class="profile-score-alert" v-if="profile_data.score_alert.male_audience">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        男性中心のフォロワーのため、女性向け商材のPRに不向きです。
      </div>
      <div class="profile-score-alert" v-if="profile_data.score_alert.pr_rate">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        PR投稿の頻度が高いため、PR効果が薄い可能性があります。
      </div>
      <div class="profile-score-alert" v-if="profile_data.score_alert.egr">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        エンゲージメント率が1%を下回っています。
      </div>
      <div class="profile-score-alert" v-if="profile_data.score_alert.growth">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        フォロワーが減少傾向です。
      </div>
      <div class="profile-score-alert" v-if="profile_data.score_alert.frequency">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        投稿頻度が低く、アカウントパワーが低下する可能性があります。
      </div>
      <div class="profile-score-alert" v-if="profile_data.score_alert.ff">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        相互フォローによりフォロワーを獲得している可能性があります。
      </div>
      <div class="profile-score-alert" v-if="profile_data.score_alert.no_gender">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        性別データが不足しており、スコアが低く表示されている可能性があります。
      </div>
    </template>
    <template v-else-if="profile_data.score_alert === false">
      <div class="profile-score-alert" style="margin-bottom: 0px">
        <font-awesome-icon :icon="['fas', 'check-circle']" style="margin-right: 5px; color:#0095f6"/>
        良好なアカウントです。
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    tabs: String,
    profile_data: Object
  }
}
</script>
